import React from 'react';

import { Container } from '../Containers';

import {
  primary as primaryColor,
  primaryDark,
  bright as brightColor,
} from '../../colors';
import { h5 } from '../../fontSizes';
import { minWidth, tablet } from '../../screenSizes';

export const BokaBord = () => (
  <Container
    key="BokaBordSection"
    css={`
      display: flex;
      justify-content: center;
    `}
  >
    <button
      data-hash="a3672664914aba7f45899616e62c32ea"
      // this classname is selected by the script, don't remove
      className="waiteraid-widget"
      css={`
        font-size: ${h5};
        color: ${brightColor};
        border: ${`2px solid ${primaryColor}`};
        padding: 12px 20px;
        background: ${primaryColor};
        text-transform: uppercase;
        text-decoration: none;
        font-weight: 700;
        cursor: pointer;

        &:hover,
        &:hover:focus,
        &:active:hover,
        &:focus:hover,
        &:focus:hover:active {
          color: ${brightColor};
          background: ${primaryDark}
          border-color: ${primaryDark};
          text-decoration: none;
        }

        &:active,
        &:focus,
        &:active:focus {
          color: ${brightColor};
          text-decoration: none;
        }

      ${minWidth(tablet)} {
          padding: 16px 30px;
        }
      `}
    >
      Boka Bord
    </button>
  </Container>
);



// WEBPACK FOOTER //
// ./app/components/BookSection/BokaBord.js